<template>
  <div class="container">
		<div class="handle-container">
			<div class="search-container">
				可拖拽调整位置
			</div>
			<div class="btn-style">
        <Button type="primary" icon="md-add" @click="openModal">添加规则</Button>
			</div>
		</div>
		<div class="table-container">
			<Table :columns="columns" :data="showList" draggable @on-drag-drop="hagndleDrop">
				<template slot-scope="{ row }" slot="rule">
          <span v-for="(item, index) in row.conditions" :key="index">
            {{getConditionLabel(item)}}；
          </span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span>
            {{{ rate: '设置评级：', sms: '发送短信', api: '接口调用' }[row.action]}}
            {{ row.action === 'rate' ? `${ratings[row.action_data] || ''}(${row.action_data})` : '' }}
            {{ row.action === 'api' ? `${apiSettings[row.action_data] && apiSettings[row.action_data].name || ''}` : '' }}
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="option">
					<span class="edit-style" @click='handleEdit(row, pageSize * (page - 1) +index)'>编辑</span>
					<Poptip
						confirm
						title="确认要删除这条数据吗？"
						@on-ok="delRule(pageSize * (page - 1) +index)"
						transfer
					>
						<span class="del-style">删除</span>
					</Poptip>
        </template>
			</Table>
		</div>
		<div class="flex flex-justify-center">
			<Page :total="rules.length" :current.sync="page" :page-size="pageSize"/>
		</div>
		<!-- <var-modal v-model="showRuleModal" @onSubmit="editVar" :curRule="curRule"/> -->
    <rule-modal
      v-model="showRuleModal"
      :curRule="curRule" 
      @onCancel="curRule = undefined"
      @onSubmit="editRule"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import RuleModal from './components/ruleModal.vue';

export default {
  components: {
    RuleModal,
  },
  data() {
		return {
			showRuleModal: false,
			curRule: undefined,
			columns: [
				{title: '序号', width: 80, type: 'index'},
				{title: '规则', slot: 'rule'},
				{title: '动作', slot: 'action'},
				{title: '标签', key: 'tag'},
				{title: '操作', slot: 'option'},
			],
      operator: {
        gt: '大于',
        lt: '小于',
        gte: '大于等于',
        lte: '小于等于',
        equals: '等于',
        all: '包含所有',
        any: '包含任一',
      },
			pageSize: 20,
			page: 1,
		}
	},
	computed: {
    ...mapState('rules', [
			'rules'
    ]),
    ...mapState('setting', ['sysVars', 'ratings', 'apiSettings']),
    ...mapState('intents', [
			'intents'
    ]),
		showList() {
			const startIndex = (this.page - 1) * this.pageSize;
			return this.rules?.slice(startIndex, startIndex + this.pageSize) || [];
		},
	},
	methods: {
    ...mapActions('rules', ['setRule', 'delRule', 'modifyPosition']),
		openModal() {
      this.showRuleModal = true;
		},
		editRule(rule) {
			this.setRule(rule)
		},
		handleEdit(rule, index) {
			this.curRule = { ...rule, index };
      this.openModal();
		},

    getConditionLabel(condition) {
      const { rule = '', op, value } = condition;
			let varName = rule.split(':')[1];
			if (rule.indexOf('sys:') === 0) {
				const sysVar = this.sysVars.find(sysVar => sysVar.id === varName);
				varName = sysVar?.name;
			} else if (rule.indexOf('intent') === 0) {
				const intentId = rule.slice(4);
				const intent = this.intents.find(intent => intent.id === varName);
				varName = `${intent?.name || ''} 次数`;
			}
      return `${varName} ${this.operator[op]} ${value}`
    },
		hagndleDrop(originalP, newP) {
			this.modifyPosition({ originalP, newP })
		},
	}
}
</script>
<style lang="scss" scoped>
.container{
	width: 100%;
	padding: 20px;
	background-color: #fff;
	.handle-container{
		width: 100%;
		display: flex;
		justify-content: space-between;
		.btn-style{
			display: flex;
			justify-items: flex-start;
			div{
				padding: 10px 20px;
				border-radius: 20px;
				font-size: 14px;
				color: #fff;
			}
			.add-style{
				background-color: #ffa800;
				margin-right: 10px;
			}
			.export-style{
				background-color: #6186cf;
			}
			i{
				font-size: 18px;
			}
		}
	}
	.table-container{
		padding: 20px 0;
	}
	.del-style{
		color: #e72e2e;
    cursor: pointer;
		
	}
	.edit-style{
		display: inline-block;
		color: #6186cf;
		padding-right: 20px;
    cursor: pointer;
	}
}
</style>